export enum ROLE_TYPE {
  ADMIN = 'app_admin',
  PUBLISHER = 'publisher',
  COLLECTION_PUBLISHER = 'publisher:collections',
  DEBUG = 'debug',
  SUPER = 'super'
}
